module.exports = __webpack_public_path__ + "055ec116865888709164d1e737fcfadb.png";